import React from 'react';

// Red de seguridad en la raíz. Sin esto, un error de render (por ejemplo un
// bundle viejo que recibe una respuesta del backend que ya no espera) desmonta
// el árbol entero y la persona ve una página en blanco, sin mensaje y sin
// saber que alcanza con recargar.
//
// Fuera de React a propósito: no usa MUI, el router ni el contexto, que pueden
// ser justamente lo que falló.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#F5F5F5', fontFamily: 'Montserrat, Arial, sans-serif', padding: 16,
      }}>
        <div style={{
          background: '#fff', borderRadius: 14, padding: '28px 24px', maxWidth: 420, width: '100%',
          textAlign: 'center', boxShadow: '0 4px 20px rgba(22,50,68,0.12)',
        }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#163244', marginBottom: 8 }}>
            Algo salió mal
          </div>
          <div style={{ fontSize: 14, color: '#5a6e7f', lineHeight: 1.5, marginBottom: 20 }}>
            Puede que haya una versión nueva de Fixo. Recargá la página para seguir.
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#E7A432', color: '#163244', border: 'none', borderRadius: 50,
              padding: '11px 28px', fontWeight: 800, fontSize: 14, cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Recargar
          </button>
        </div>
      </div>
    );
  }
}
